export default import.meta.ROLLDOWN_FILE_URL_ookwDNlnETlFW1YWWz9xqQ